import React from 'react';

import { CircularProgress, ButtonProps } from '@material-ui/core';

import { Button } from './style';

export interface ButtonComponentProps extends ButtonProps {
  text?: string;
  Icon?: React.FC;
  loading?: boolean;
  loaderSize?: string; // loaderSize used as a string because it is a value that are used as a CSS property
}

export function ButtonComponent({ text, Icon, loading, loaderSize, ...rest }: ButtonComponentProps) {
  return (
    <Button
      color="default"
      type="button"
      variant="contained"
      size="small"
      {...rest}
      disabled={loading || rest.disabled}
    >
      {loading ? (
        <CircularProgress size={loaderSize ?? 20} color="inherit" />
      ) : (
        <>
          {Icon && <Icon />}
          <span>{text}</span>
        </>
      )}
    </Button>
  );
}
